import { X } from "lucide-react";

/**
 * <ResetFiltersChip
 *    active={boolean}
 *    onReset={() => void}
 *    label="Reset filters"  // optional
 * />
 * Renders nothing when not active. Use near the filter row of a list page when
 * any filter has been changed from defaults (sticky persisted across sessions).
 */
export default function ResetFiltersChip({ active, onReset, label = "Reset filters" }) {
  if (!active) return null;
  return (
    <button
      type="button"
      onClick={onReset}
      className="inline-flex items-center gap-1.5 h-7 px-2.5 text-xs font-medium border border-orange-200 text-orange-700 bg-orange-50 hover:bg-orange-100 hover:border-orange-300 rounded-sm transition-colors"
      data-testid="reset-filters-chip"
      title="Filters are sticky across sessions. Click to restore defaults."
    >
      <X className="w-3 h-3" />
      {label}
    </button>
  );
}
